const useQueryParams = () => {
  const get = (key) => {
    return new URLSearchParams(window.location.search).get(key);
  };

  const set = (key, value) => {
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    window.history.pushState({}, "", url.toString());
  };

  const clear = (key) => {
    const url = new URL(window.location.href);
    url.searchParams.delete(key);
    window.history.pushState({}, "", url.toString());
  };

  return {
    get,
    set,
    clear,
  };
};

export default useQueryParams;
